import { useGetContactQuery } from '@common/services';
import { DsfrModal } from '@common/ui';
import React, { ReactNode } from 'react';
import { MdPhone } from 'react-icons/md';
import { RiMailFill } from 'react-icons/ri';
import './contactModal.css';

export const ContactModal = ({ dsfrModal }: ContactModalProps) => {
  const { data: contact } = useGetContactQuery();

  const contents: ContactContent[] = [
    {
      icon: <MdPhone />,
      label: 'Téléphone',
      value: contact?.phone,
    },
    {
      icon: <RiMailFill />,
      label: 'Courriel',
      value: contact?.email,
    },
  ];

  return (
    <dsfrModal.Component title={'Contacter France compétences'}
                         size="large"
                         topAnchor={false}
                         buttons={[{ children: 'FERMER', doClosesModal: true }]}>

      <div className={'contact-modal-contents'}>

        {contents.map(({ icon, label, value }, index) => (
          <div key={index} className={'contact-modal-item'}>

            <div className={'contact-modal-item-title'}>
              <span className={'contact-modal-item-icon'}>{icon}</span>
              <span className={'contact-modal-item-label'}>{label}</span>
            </div>

            <span>{value}</span>
          </div>
        ))}
      </div>
    </dsfrModal.Component>
  );
};

interface ContactModalProps {
  dsfrModal: DsfrModal;
}

interface ContactContent {
  icon: ReactNode;
  label: string;
  value?: string;
}